<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row class="my-2 subtitle-2 secondary--text pl-12">
                Month max sales
            </v-row>
            <v-divider />
            <!--month sales tab-->
            <div v-if="monthSales.length > 0">
                <v-expansion-panels focusable v-model="tab">
                    <v-expansion-panel v-for="(item, index) in sales_arr" :key="item.id">
                        <v-expansion-panel-header class="font-weight-bold secondary--text">
                            <!-- month-->
                            Month {{ index + 1 }}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="body-2">
                            <!--table head-->
                            <v-row class="subtitle-2" no-gutters>
                                <v-col cols="1" class="text-left">Segment</v-col>
                                <v-divider vertical></v-divider>

                                <v-col v-for="seg in item" 
                                    :key="seg.segment.id"
                                    >
                                    <v-row class="subtitle-2" no-gutters>
                                        <v-col class="text-center" >
                                            {{ seg.segment.name }}
                                        </v-col>
                                        <v-divider vertical></v-divider>
                                    </v-row>    
                                </v-col>  
                            </v-row>
                            <v-divider />
                            <v-row class="subtitle-2" no-gutters>
                                <v-col cols="1" class="text-left">Product</v-col>
                                <v-divider vertical></v-divider>
                                <v-col v-for="(seg, index) in item" :key="index">
                                    <v-row class="subtitle-2" no-gutters>
                                        <v-col class="text-center">BI</v-col>
                                        <v-divider vertical></v-divider>
                                        <v-col class="text-center">BSI</v-col>
                                        <v-divider vertical></v-divider>
                                        <v-col class="text-center">BNI</v-col>
                                        <v-divider vertical></v-divider>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-divider />
                            <!--- table month max sales-->
                            <v-row v-for="product in products" :key="product.productId" no-gutters>
                                <v-col cols="1" class="text-left">{{ product.trademark.name }} {{ product.model }}</v-col>
                                <v-col v-for="seg in item" :key="seg.segment.id">
                                    <v-row no-gutters>
                                        <v-col class="text-center" v-if="maxSales(product.productId, seg.segment.id, index, '_bi')">
                                            ({{rank(product.productId, seg.segment.id, index, '_bi') }}) -
                                            {{ maxSales(product.productId, seg.segment.id,  index, '_bi') }}
                                        </v-col>
                                        <v-col class="text-center" v-else>
                                            {{ maxSales(product.productId, seg.segment.id, index, '_bi') }}
                                        </v-col>
                                        <v-col class="text-center" v-if="maxSales(product.productId, seg.segment.id, index, '_bsi')">
                                            ({{ rank(product.productId, seg.segment.id, index, '_bsi') }}) - 
                                            {{ maxSales(product.productId, seg.segment.id,  index, '_bsi') }}
                                        </v-col>
                                        <v-col class="text-center" v-else>
                                            {{ maxSales(product.productId, seg.segment.id, index, '_bsi') }}
                                        </v-col>
                                        <v-col class="text-center" v-if="maxSales(product.productId, seg.segment.id, index, '_bni')">
                                            ({{ rank(product.productId, seg.segment.id, index, '_bni') }}) - 
                                            {{ maxSales(product.productId, seg.segment.id,  index, '_bni') }}
                                        </v-col>
                                        <v-col class="text-center" v-else>
                                            {{ maxSales(product.productId, seg.segment.id, index, '_bni') }}
                                        </v-col>  
                                    </v-row>                                             
                                </v-col>
                            </v-row>  
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </div>
            <v-row v-else class="mt-4" justify="center">
                there are no sales yet
            </v-row>
        </div>
        <!--!loading-->
        <div v-else class="text-center">
            <loader></loader>
        </div>
    </v-container>
</template>
<script>
import Loader from '../../../layouts/Loader.vue';
import { localeNumber } from '../../../functions/common';
export default {
    data() {
        return {
            tab: 0,
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
        monthSales() {
            return this.$store.getters.monthSales;
        },
        products() {
            const res = [];
            if (this.monthSales.length > 0) {
                this.monthSales.forEach((item) => {
                    const inArr = res.find((product) => product.productId === item.productId);
                    if (!inArr) {
                        res.push(item)
                    }
                });
            }
            console.log(res)
            return res;
        },
        sales_arr() {
            const res = [];
            if (this.monthSales.length > 0) {
                for (let month = 0; month < 12; month++) {
                    res[month] = this.monthSales.filter((item) => item.month === month + 1);
                    const segments = [{
                        segment: res[month][0].segment,
                        models: [],
                    }];
                    res[month].forEach((item) => {
                        const inArr = segments.find((it) => it.segment.id === item.segmentId);
                        if (!inArr) {
                            segments.push({
                                segment: item.segment,
                                models: [item],
                            })
                        } else {
                            inArr.models.push(item)
                        }
                    });
                    res[month] = segments;
                }
            }
            return res;
        }
        
    },
    methods: {
        localeNumber(number) {
            return localeNumber(number, this.locale)
        },
        maxSales(productId, segmentId,  month, subsegment) {
            const matched_arr = this.sales_arr[month];
            const segment = matched_arr.find((item) => item.segment.id == segmentId);
            let max_sales = 0;
            
            const product = segment.models.find((prod) => prod.productId == productId);
            if (product) {
               max_sales =  product[`max_sales${subsegment}`]; 
            }
            return max_sales;     
        },
        rank(productId, segmentId, month, subsegment) {
            const matched_arr = this.sales_arr[month];
            const segment = matched_arr.find((item) => item.segment.id == segmentId);
            let rank = 0;

            const product = segment.models.find((prod) => prod.productId == productId);
            if (product) {
                rank = product[`rank${subsegment}`];
            }
            return rank;
        },
    },
    components: { Loader }
}
</script>
